module.exports = __webpack_public_path__ + "img/second_one.9fbc5b30.png";